var map = {
  "./mobile/index": [
    "68709",
    9,
    "9598",
    "73416",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "51287",
    "75938"
  ],
  "./desktop/index.js": [
    "39777",
    9,
    "9598",
    "76225",
    "62815",
    "16539",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "51287",
    "95094"
  ],
  "./desktop/index": [
    "39777",
    9,
    "9598",
    "76225",
    "62815",
    "16539",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "51287",
    "95094"
  ],
  "./desktop/Indiaworldcases": [
    "59611",
    9,
    "9598",
    "51287",
    "48377"
  ],
  "./mobile/index.js": [
    "68709",
    9,
    "9598",
    "73416",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "51287",
    "75938"
  ],
  "./mobile": [
    "68709",
    9,
    "9598",
    "73416",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "51287",
    "75938"
  ],
  "./mobile/Indiaworldcases": [
    "78879",
    9,
    "9598",
    "51287",
    "885"
  ],
  "./desktop": [
    "39777",
    9,
    "9598",
    "76225",
    "62815",
    "16539",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "51287",
    "95094"
  ],
  "./desktop/": [
    "39777",
    9,
    "9598",
    "76225",
    "62815",
    "16539",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "51287",
    "95094"
  ],
  "./desktop/Indiaworldcases.js": [
    "59611",
    9,
    "9598",
    "51287",
    "48377"
  ],
  "./mobile/": [
    "68709",
    9,
    "9598",
    "73416",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "51287",
    "75938"
  ],
  "./mobile/Indiaworldcases.scss": [
    "595",
    7,
    "35846"
  ],
  "./desktop/Indiaworldcases.scss": [
    "82549",
    7,
    "68154"
  ],
  "./mobile/Indiaworldcases.js": [
    "78879",
    9,
    "9598",
    "51287",
    "885"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 56967;
module.exports = __rspack_async_context;
